// For emitters in comment section
export default function useCommentEvents(context: any) {
  function emitCommentUpdated(comment: any) {
    context.emit('comment-updated', comment);
  }
  function emitCommentFormOpen(comment: any) {
    context.emit('comment-form-open', comment);
  }
  function emitCommentFormClose() {
    context.emit('comment-form-close');
  }
  function emitCommentVoteSent(vote: any) {
    context.emit('comment-vote-sent', vote);
  }

  return { emitCommentUpdated, emitCommentFormClose, emitCommentFormOpen, emitCommentVoteSent };
}
